import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginRegisterGuard } from './core/guards/login-register.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
    data: { title: 'HOME.PAGE_TITLE' },
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./features/register/register.routes').then(
        (m) => m.REGISTER_ROUTES,
      ),
    canActivate: [LoginRegisterGuard],
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./features/checkout/checkout.routes').then(
        (m) => m.CHECKOUT_ROUTES,
      ),
    canActivate: [AuthGuard],
    data: { title: 'CHECKOUT.PAGE_TITLE' },
  },
  {
    path: 'Wishlist-registration',
    pathMatch: 'full',
    redirectTo: 'wishlist-registration',
  },
  {
    path: 'wishlist-registration',
    loadChildren: () =>
      import(
        './features/wishlist-registration/wishlist-registration.routes'
      ).then((m) => m.WISHLIST_REGISTRATION_ROUTES),
    data: { title: 'MARID_DARK.PAGE_TITLE' },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
